import { render } from "./CompanyAngles.vue?vue&type=template&id=c5715fb0&ts=true"
import script from "./CompanyAngles.vue?vue&type=script&lang=ts"
export * from "./CompanyAngles.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./CompanyAngles.vue?vue&type=style&index=0&id=c5715fb0&lang=scss&module=true"
cssModules["$style"] = style0
import style1 from "./CompanyAngles.vue?vue&type=style&index=1&id=c5715fb0&lang=scss&module=true"
cssModules["$style"] = style1

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__